<template>
  <div class="body-wrap">

    <div class="body-main">

      <div class="operation-btns">
        <el-button size="mini" @click="getList(1)" :loading="searchLoading">查询</el-button>
        <el-button size="mini" @click="doClosing(undefined, 0)" :loading="closingLoading">月结</el-button>
        <el-button size="mini" @click="doClosing(undefined, 1)" :loading="closingLoading">反月结</el-button>

        <el-button size="mini" @click="showConfig()">月结设置</el-button>
      </div>

      <div class="search-wrap" >

        <div class="sw-title">查询条件</div>
        <div class="sw-wrap">

          <el-descriptions title="" size="mini" :column="2" border>
            <el-descriptions-item label="小区">
              <el-input placeholder="请选择..." size="mini" v-model="form.pindex_name" readonly @clear="clearHouse" clearable class="input-with-select">
                <el-button slot="append" @click="showSelectHouse">选择</el-button>
                <el-button type="danger" slot="append" @click="clearHouse">清除</el-button>
              </el-input>
            </el-descriptions-item>
            <el-descriptions-item label="月结状态">
              <el-checkbox-group v-model="form.is_closing">
                <el-checkbox :label="1">已月结</el-checkbox>
                <el-checkbox :label="0">未月结</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>
            <el-descriptions-item label="所属期">
              <el-date-picker type="month" format="yyyyMM" value-format="yyyyMM" v-model="form.account_book" size="mini" placeholder="选择日期"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="进度">
              <el-progress :text-inside="true" :stroke-width="20" :percentage="process.percentage"></el-progress>
            </el-descriptions-item>
          </el-descriptions>


        </div>

      </div>

      <div class="table-wrap">
        <el-table ref="multipleTable" v-loading="searchLoading" height="47vh" border style="width: 99%" :element-loading-text="searchLoadingText" :data="tableData" @selection-change="handleSelectionChange">
          <el-table-column prop="id" type="selection" align="center" width="50"></el-table-column>
          <el-table-column prop="name" label="小区" align="center"></el-table-column>
          <el-table-column prop="current_month" label="当前所属期" align="center"></el-table-column>
          <el-table-column prop="account_book" label="所属期" align="center"></el-table-column>
          <el-table-column prop="is_closing_text" label="月结状态" align="center"></el-table-column>
          <el-table-column prop="update_time_formatted" label="月结时间" align="center"></el-table-column>
          <el-table-column prop="administrators" label="操作员" align="center"></el-table-column>
          <el-table-column prop="id" label="操作" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.can_do && scope.row.is_closing === 0" type="primary" size="mini" @click="doClosing(scope.row, scope.row.is_closing)">月结</el-button>
              <el-button v-if="scope.row.can_do && scope.row.is_closing === 1" type="danger" size="mini" @click="doClosing(scope.row, scope.row.is_closing)">反月结</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrap">
          <el-pagination
            style="float: right; margin-top: 10px; margin-right: 20px"
            background
            :small="true"
            layout="sizes,prev, pager, next"
            :page-size.sync="pageSize"
            :total="total"
            :current-page.sync="page"
            :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
          >
          </el-pagination>
        </div>



        <div class="tips">
          月结规则：<br>
          1.交账的票据要销号，挂账的票据需要核销<br>
          2.已生成的应收款需要全部审核<br>
          3.仪表抄表需要计算<br>
          4.上一账期要月结
        </div>
        <div class="tips">
          月结规则：<br>
          1.月结只能月结上个月的<br>
          2.上一所属期要月结<br>
          3.反月结后仅取消月结标记,修改月结所属期<br>
          4.月结或反月结后不能走应收调整和减免,只能走调减<br>
<!--          3.反月结仅取消月结标记，恢复应收和减免的的可修改性<br>
          4.反月结后,月结期间的调减不会变更<br>-->
        </div>
      </div>



      <!-- 选择房产 -->
      <el-dialog title="选择房产" :visible.sync="selectDialogVisible" :close-on-click-modal="true" class="business-dialog" width="500px">

        <div style="display: flex;">
          <el-input size="mini" placeholder="请输入关键字" v-model="selectKeyword"></el-input>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="searchHouse" :loading="selectSearchLoading" style="margin-left: 10px;">搜 索</el-button>
        </div>

        <el-table v-loading="selectSearchLoading" :data="houseData" @selection-change="selectChange" height="400" style="margin-top: 10px;">
          <el-table-column prop="id" type="selection" align="center" width="50"></el-table-column>
          <el-table-column prop="name" label="项目"></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveSelect" :loading="selectSearchLoading">保 存</el-button>
          <el-button @click="selectDialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>

      <!-- 月结设置 -->
      <el-dialog title="月结设置" :visible.sync="configDialogVisible" :close-on-click-modal="true" class="business-dialog" width="600px">

        <el-descriptions :column="1" size="mini" border>
          <el-descriptions-item label="月结日">
            <div class="closing-date-row">
              <el-radio-group v-model="configForm.closing_type" @change="closingTypeChange">
                <el-radio :label="0">每月最后一天</el-radio>
                <el-radio :label="1">每月固定日期</el-radio>
              </el-radio-group>
              <div class="inp">
<!--                <el-input type="number" min="1" max="28" v-model="configForm.closing_date" @change="closingDateChange"></el-input>-->
                <el-input-number :min="0" :max="28" :step="1" v-model="configForm.closing_date"  @change="closingDateChange"></el-input-number>
              </div>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="帐期格式">
            <el-input v-model="configForm.date_format"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="数据统计">
            <el-checkbox v-model="configForm.is_close_stat">月结是否统计数据</el-checkbox>
          </el-descriptions-item>
        </el-descriptions>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveConfig" :loading="configSaveLoading">保 存</el-button>
          <el-button @click="configDialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>

    </div>

  </div>
</template>
<script>
import moment from "moment/moment";
export default {
  name: 'month-closing',
  data () {
    return {
      form: {
        pindex_id: '',
        pindex_name: '',
        is_closing: [0],
        account_book: '',
        percentage: 0,
      },

      searchLoading: false,
      searchLoadingText: '',
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dataSelectItem: [],

      selectDialogVisible: false,
      selectSearchLoading: false,
      selectKeyword: '',
      houseData: [],
      houseSelectItem: [],

      closingLoading: false,

      process: {
        total: 0,
        finished: 0,
        percentage: 0,
      },

      configSaveLoading: false,
      configDialogVisible: false,
      configForm: {

      }

    }
  },
  mounted() {
    this.form.account_book = moment().subtract(1, 'months').format('YYYYMM');
    this.getList(1);
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  watch: {
    "page"(n) {
      this.getList();
    },
    "pageSize"(n) {
      this.getList();
    },
  },
  methods: {
    handleSelectionChange(data) {
      this.dataSelectItem = data
    },

    clearHouse() {
      this.form.pindex_id = ''
      this.form.pindex_name = ''
    },

    getList(page) {
      if(page){
        this.page = page;
      }
      this.searchLoading = true
      let params = Object.assign({}, this.form)
      this.$myhttp.post('admin/getMonthClosingList?page='+this.page+'&pageSize=' + this.pageSize, params,{
        "Content-Type": "application/x-www-form-urlencoded",
      }).then(resp => {
        let res = resp.data
        this.searchLoading = false
        if(res.code == 200) {
          this.tableData = res.data
          this.total = res.total
        } else {
          this.tableData = []
          this.total = 0
        }

      })

    },

    pageChange(data) {
      this.page = data
      this.getList()
    },

    showSelectHouse() {
      this.selectDialogVisible = true
      this.selectKeyword = ''
    },

    searchHouse() {

      this.selectSearchLoading = true
      this.$myhttp.get('admin/getMonthHouseList', {params: {keyword: this.selectKeyword}}).then(resp => {
        let res = resp.data
        if(res.code == 200) {
          this.houseData = res.data
        } else {
          this.houseData = []
        }
        this.selectSearchLoading = false
      })


    },

    selectChange(data) {
      this.houseSelectItem = data
    },

    saveSelect() {
      this.form.pindex_id = this.houseSelectItem.map(item => item.id).join(',')
      this.form.pindex_name = this.houseSelectItem.map(item => item.name).join(',')
      this.selectDialogVisible = false
    },

    doClosing(item, is_closing) {
      console.log('item',item)

      let data = []
      let label = is_closing ? '反月结' : '月结'

      if(item) {

        data.push({
          id: item.id,
          pindex_id: item.pindex_id,
          account_book: item.account_book
        })

      } else {
        console.log('顶部')
        console.log('dataSelectItem',this.dataSelectItem)

        if(this.dataSelectItem.length == 0) {
          this.$message.warning(`请选择${label}数据`)
          return false
        }

        this.dataSelectItem.forEach(item => {
          if(item.can_do == 1 && item.is_closing == is_closing) {
            data.push({
              id: item.id,
              pindex_id: item.pindex_id,
              account_book: item.account_book
            })
          }
        })

        if(data.length == 0) {
          this.$message.warning(`没有可供${label}的数据`)
          return false
        }

      }

      this.closingLoading = true
      this.searchLoading = true
      this.searchLoadingText = '正在月结...'

      this.process = {
        total: data.length,
        finished: 0,
        percentage: 0,
      }

      this.doClosingAction(data, is_closing)


    },

    doClosingAction(list, is_closing) {

      if(list.length > 0) {
        let data = list.shift();
        this.$myhttp.post('admin/doMonthClosing', Object.assign({is_closing: is_closing}, data)).then(resp => {

          this.process.finished += 1
          this.process.percentage = Math.floor(this.process.finished / this.process.total * 100)

          this.doClosingAction(list, is_closing)
        })
      } else {
        this.closingLoading = false
        this.searchLoading = false
        this.searchLoadingText = ''
        this.getList()
      }

    },

    showConfig() {

      this.getConfig()
      this.configDialogVisible = true

    },

    getConfig() {

      this.$myhttp.get('admin/getMonthClosingConfig').then(resp => {
        let res = resp.data
        if(res.code == 200) {

          this.configForm = {
            closing_type: res.data.closing_date == 0 ? 0 : 1,
            closing_date: res.data.closing_date,
            date_format: res.data.date_format,
            is_close_stat: res.data.is_close_stat == 1
          }

        }
      })

    },

    closingDateChange(val) {
      this.configForm.closing_type = Number(val) > 0 ? 1 : 0
    },

    closingTypeChange(val) {
      if(Number(val) == 0) {
        this.configForm.closing_date = '0'
      }
    },

    saveConfig() {

      this.configSaveLoading = true
      let data = Object.assign({}, this.configForm)
      this.$myhttp.post('admin/saveMonthClosingConfig', data).then(resp => {
        let res = resp.data
        this.configSaveLoading = false
        if(res.code == 200) {
          this.configDialogVisible = false
          this.messageSuccess(res.msg)
        }else{
          this.configDialogVisible = false
          this.messageError(res.msg)
        }

      })

    },

    message(res) {
      this.$message({type: res.code == 0 ? 'success' : 'error', message: res.msg})
    },
    messageSuccess(msg) {
      this.$message({type: 'success', message: msg})
    },
    messageError(msg) {
      this.$message({type: 'error', message: msg})
    },

  },

}
</script>
<style lang="scss" scoped>

  @import '../Project/common.scss';

  /deep/.sw-wrap .el-checkbox {
    margin-right: 15px;
  }

  .body-wrap {
    display: flex;

    .body-main {
      flex: 1;
      width: 100%;
    }

    .search-wrap {
      width: 100%;
      border: 1px solid #EBEEF5;
      flex-direction: column;

      .sw-title {
        margin: 0;
        font-size: 12px;
        color: #909399;
        background: #fafafa;
        padding: 5px;
        border-bottom: 1px solid #EBEEF5;

        .house-name {
          margin-left: 20px;
        }
      }

      .sw-wrap {
        padding: 10px;


      }
    }
  }

  .input-with-select {
    max-width: 350px
  }

  .closing-date-row {
    display: flex;
    align-items: center;

    .inp {
      width: 150px;
      margin-left: 15px;
    }
  }

  .tips {
    margin-top: 15px;
    color: #ff0000;
  }

</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/monthClosing.vue